






















import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { Position } from '~/models/app/position'
import { mapGetters, mapState } from 'vuex'
import CClassifiedImagesViewer from '~/components/shared/configurable/classified/image/CClassifiedImagesViewer.vue'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import DiscountPercentageTag from '~/components/car/classifieds/DiscountPercentageTag.vue'
import { ShortVideo } from '~/models/short-video'
export default defineComponent({
  components: { CClassifiedImagesViewer, DiscountPercentageTag },
  props: {
    classified: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
    type: {
      type: String,
      required: false,
      default: 'carousel'
    },
    noThumbs: { type: Boolean, required: false, default: false },
    counterPosition: {
      type: String as PropType<Position>,
      required: false,
      default: Position.BOTTOM
    },
    imageClass: {
      type: [String, Object],
      default: null
    },
    displayVideo: {
      type: Boolean,
      default: false
    },
    shortVideos: {
      type: Array as PropType<ShortVideo[]>,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      refs: state => state.classifieds.view.refs,
      seller: state => state.classifieds.view.seller
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, [
      'sellerIsBlacklistedSuspiciousOrFraudster',
      'isRentalClassified',
      'isOnlyLeasing'
    ])
  }
})
